/** Research guide §6 — Publishing results (`research/ResearchPublishView.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, Callout, HelpSectionCard, Li, P, SubHead } from '../HelpPrimitives.js';

export function ResearchPublish(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('research-publish')}>
      <P>
        The last step — no AI involved, purely exporting what you&rsquo;ve already accepted. A
        summary shows how many companies were accepted, broken down by grade.
      </P>

      <SubHead>Three independent options</SubHead>
      <Bullets>
        <Li>Save results to Google Sheets.</Li>
        <Li>Send them to the recruiter.</Li>
        <Li>
          Save to the company library — checked by default, so future requests benefit from the
          cache.
        </Li>
      </Bullets>

      <P>
        A warning banner appears if any accepted company still needs human verification. Click{' '}
        <Btn>Publish</Btn> when you&rsquo;re ready; the success dialog gives you the Sheets link
        (with a copy button) and a way back to the library.
      </P>

      <Callout title="Nothing here spends anything">
        <P>Publishing only exports and saves what Review already accepted — no AI call runs.</P>
      </Callout>
    </HelpSectionCard>
  );
}
